import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import img1 from "../../assets/images/tricoma/img1.png";

const pStyle = {
  fontSize: "18px",
  marginBottom: "16px"
};

export default function JtlGuide() {
  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="tricoma.step1"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="tricoma.step2"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
        <br />
        <br />
        <img src={img1} style={{ width: "100%" }} />
        <br />
      </Typography>
      <Typography sx={{ fontWeight: 800 }}>
        <FormattedMessage
          id="tricoma.restApiToken"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="tricoma.step3"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="tricoma.step4"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="tricoma.step5"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
    </Box>
  );
}
